module.exports = __webpack_public_path__ + "img/pick5_g.1aaa8aaf.png";